import React from 'react';
import { Link, useParams } from 'react-router-dom';
import PageLayout, { CtaBox } from '../../GlobalComp/PageLayout/PageLayout';
import Classes from '../../GlobalComp/PageLayout/PageLayout.module.css';
import Seo, { breadcrumbSchema, serviceSchema } from '../../GlobalComp/Seo/Seo';
import NotFound from '../NotFound/NotFound';
import { getService, SERVICES } from '../../../data/services';
import AreasServed from '../Home/Sections/AreasServed/AreasServed';
import { SITE } from '../../../data/siteConfig';
import { altFor, srcSetFor } from '../../../data/photos';

export default function Service() {
    const { slug } = useParams();
    const service = getService(slug);
    if (!service) return <NotFound />;

    const path = `/services/${service.slug}`;
    const crumbs = [
        { name: 'Home', path: '/' },
        { name: 'Services', path: '/#services' },
        { name: service.name, path },
    ];
    const description = `${service.summary} Serving Boca Raton and South Florida. Call ${SITE.phone} or book online.`;

    return (
        <>
            <Seo
                title={`${service.name} in South Florida | 561-FIX-HOME`}
                description={description}
                path={path}
                jsonLd={[
                    serviceSchema({ name: service.name, description, path }),
                    breadcrumbSchema(crumbs),
                ]}
            />
            <PageLayout
                title={`${service.name} in South Florida`}
                subtitle={service.heroText || service.summary}
                image={service.image}
            >
                <section>
                    <h2>What’s Included</h2>
                    <div className={Classes.feature}>
                        <div className={Classes.featureMedia}>
                            <img src={service.photos.feature} srcSet={srcSetFor(service.photos.feature)} sizes="(max-width: 900px) 100vw, 600px" alt={altFor(service.photos.feature)} className={Classes.featureImg} loading="lazy" />
                        </div>
                        <div className={Classes.featureBody}>
                            <p className={Classes.featureLead}>{service.intro}</p>
                            <ul className={Classes.ticks}>
                                {service.includes.map((item) => <li key={item}>{item}</li>)}
                            </ul>
                        </div>
                    </div>
                </section>

                <AreasServed boxed />

                <section className={Classes.grayBand}>
                    <h2>Other Services</h2>
                    <div className={Classes.grid}>
                        {SERVICES.filter((s) => s.slug !== service.slug).map((s) => (
                            <Link key={s.slug} to={`/services/${s.slug}`} className={Classes.card}>
                                <img src={s.icon} alt="" aria-hidden="true" />
                                <h3>{s.name}</h3>
                                <p>{s.summary}</p>
                            </Link>
                        ))}
                    </div>
                    <div className={Classes.bandCta}>
                        <a href={SITE.bookingUrl} target="_blank" rel="noopener noreferrer" className="btn btn-dark">Book an Appointment</a>
                    </div>
                </section>
                <CtaBox
                    image={service.photos.cta}
                    title={`Ready to get started on your project?`}
                    text={`Book online or call ${SITE.phone} for an honest, upfront quote from a licensed local contractor.`}
                />
            </PageLayout>
        </>
    );
}
